<template>
    <AppLayout>
        <VerifyEmailForm />
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import VerifyEmailForm from '@/components/pages/Auth/VerifyEmailForm.vue';
</script>
